import StaffSchedule from './StaffSchedule.view';

export default StaffSchedule;
